import { FC } from 'react';
import { DmIconBoot, DmIconSafe, DmIconRun } from '../icon/dmIcon';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export const ZCComp: FC = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');

    return (
        <div id="m-output" className={`${css.ZCComp} GtmModuleData-section`} data-section-id={css.ZCComp} data-section-title={t('sec12_title')}>
            <div className="text-box">
                <div className="green-text">{t('sec12_subtitle')}</div>
                <div className="title">{t('sec12_title')}</div>
                <div className="desc">{t('sec12_desc')}</div>
            </div>
            <div className="img-box">
                {locale === 'au' ? (
                    <NextImage src={require('@publicLocal/delta2max/teaser/pc/eu/au_5.jpg')} alt={t('sec12_title')} aria-label={t('sec12_title')} />
                ) : (
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zc.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/zc.jpg')}
                        alt={t('sec12_title')}
                        aria-label={t('sec12_title')}
                    />
                )}
            </div>
            <div className="item-list">
                <div className="item-box">
                    <DmIconBoot />
                    <div className="icon-text">{t('sec12_boost')}</div>
                </div>
                <div className="item-box">
                    <DmIconSafe />
                    <div className="icon-text">{t('sec12_safe')}</div>
                </div>
                <div className="item-box">
                    <DmIconRun />
                    <div className="icon-text">{t('sec12_more')}</div>
                </div>
            </div>
        </div>
    );
};
